import Vue from 'vue/dist/vue';
import { store } from 'js/modules/vue/store';
import { order } from 'js/modules/vue/modules/order-builder';
import { formatMoney } from 'helpers/utils';

Vue.component('modal', {
    template: '#modal-template',
    data: function () {
        return {
            ReplacementBrands: [],
        };
    },
    props: {
        data: Object,
    },
    computed: {
        price: function () {
            return formatMoney(order.state.Modal.Data.Inventory.Product.ActualCost);
        },
        availability: function () {
            let html = ``;
            switch (order.state.Modal.Data.Inventory.Product.Availability) {
                case 100:
                    html =
                        'Yes <i class="ob__overview__icon success fa fa-check" aria-hidden="true"></i>';
                    break;
                case 300:
                    html = `Backordered <i aria-hidden="true" class="ob__overview__icon alert fa fa-exclamation-triangle"></i>`;
                    break;
                case 200:
                    html = `SmartShip <img class="ob__overview__icon" src="/assets/smartship.png">`;
                    break;
                default:
            }
            return html;
        },
        originalPart: function () {
            return `${order.state.CrossReference.SelectedPart.Product.ManufacturerCode}, ${order.state.CrossReference.SelectedPart.Product.PartNumber}`;
        },
        replaces: function () {
            this.ReplacementBrands = [];
            let brands = `${order.state.Modal.Data.Replaces}`.split(',');
            let output = [];
            brands.map((brand) => {
                let title = brand.split(': ')[0];
                let parts = brand.split(': ')[1].split(' ');
                output.push({ title: title, parts: parts });
            });
            this.ReplacementBrands = output;
        },
        title: function () {
            return order.state.Modal.Data.ProductTitle || '';
        },
        mpn: function () {
            return `MPN: ${order.state.Modal.Data.Inventory.Product.PartNumber}`;
        },
        qty: {
            get: function () {
                return order.state.Modal.Data.Inventory.Quantity;
            },
            set: function (value) {
                const obj = order.state.Modal.Data;
                obj.Inventory.Quantity = value;
                store.commit('UpdateModal', { Data: obj });
            },
        },
        description: function () {
            return (
                order.state.Modal.Data.Inventory.Product.Description || 'This is a replacement part'
            );
        },
        cya: function () {
            return 'This is a replacement part.';
        },
        image1: function () {
            return (
                order.state.Modal.Data.PrimaryImageURL ||
                '/assets/brands/logos/' +
                    order.state.Modal.Data.Inventory.Product.ManufacturerCode +
                    '.png'
            );
        },
        image2: function () {
            return order.state.Modal.Data.SecondaryImageURL;
        },
    },
    methods: {
        hideModal: function () {
            store.commit('ToggleModal');
        },
        addToList: function () {
            store.dispatch('OrderAdd', order.state.Modal.Data.Inventory);
            this.hideModal();
        },
    },
});
